import { Checkbox } from "primereact/checkbox";
import React from "react";
import style from '../../../assets/styles/rolePermissionEditor.module.scss';
import { wrapList } from '../../../utils/utils';

const RolePermissionEditor = ({
  idKey,
  totalList,
  availablePermissions,
  setAvailablePermissions,
  assignedPermissions,
  setAssignedPermissions,
}) => {
  const handleAssignPermission = (permission, index) => {
    setAvailablePermissions((prev) =>
      index
        ? [...prev, permission]
        : prev.filter(
            (perm) => perm?.[idKey ?? "id"] !== permission?.[idKey ?? "id"]
          )
    );
    setAssignedPermissions((prev) =>
      index
        ? prev.filter(
            (perm) => perm?.[idKey ?? "id"] !== permission?.[idKey ?? "id"]
          )
        : [...prev, permission]
    );
  };

  let permissionList = (permission, index, checked) => {
    return (
      <div key={index} className={style["list_item"]}>
        <Checkbox
          onChange={() => handleAssignPermission(permission, checked)}
          checked={checked}
          width={22}
          height={22}
        />
        <label htmlFor={`permission-${index}`}>
          <span className={style.label}>{permission.permission_name}</span>
          <span className={style.description}>{permission.description}</span>
        </label>
      </div>
    );
  };

  return (
    <div>
      {[
        { label: "Permissions", value: availablePermissions },
        { label: "Permissions Assigned", value: assignedPermissions },
      ]?.map(({ label, value }, ind) => (
        <div className={style.container + " " + style[ind === 1 && "selected"]}>
          <div className={style.title}>{label}</div>
          <div className={style.list_container}>
            {wrapList(value)?.map((array, index) => (
              <div className={style.check_container}>
                {array?.map((permission, indexed) =>
                  permissionList(
                    permission,
                    String(index) + String(indexed),
                    ind === 1 && true
                  )
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RolePermissionEditor;
